<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="类型" prop="type">
      <a-input v-model="form.data.type"/>
    </a-form-model-item>
    <a-form-model-item label="英文">
      <a-input v-model="form.data.typeEn"/>
    </a-form-model-item>
    <a-form-model-item label="图片">
      <div class="a-input">
        <simple-uploader v-model="form.data.coverPath"/>
      </div>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!sizeId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="sizeId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _querySizeTips,
  _addSizeTip,
  _updateSizeTip,
} from '@/api/appInfoDetailApi';
import SimpleUploader from '@/components/SimpleUploader.vue';
// import DictSelect from '../../../components/DictSelect.vue';

async function getSizeTip() {
  const result = await _querySizeTips(this.sizeId);
  if (result) {
    this.form.data.type = result.type;
    this.form.data.coverPath = result.coverPath;
    this.form.data.typeEn = result.typeEn;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addSizeTip({
        type: this.form.data.type,
        coverPath: this.form.data.coverPath,
        appInfoId: this.appInfoId,
        typeEn: this.form.data.typeEn,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateSizeTip(this.sizeId, {
        type: this.form.data.type,
        coverPath: this.form.data.coverPath,
        appInfoId: this.appInfoId,
        typeEn: this.form.data.typeEn,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'AppInfoDetailEdit',
  components: {
    SimpleUploader,
  },
  props: {
    appInfoId: String,
    sizeId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    sizeId() {
      if (this.sizeId) {
        this.getSizeTip();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getSizeTip,
  },
  data() {
    return {
      form: {
        data: {
          type: '',
          coverPath: '',
          typeEn: '',
        },
        rules: {
          type: [{ required: true, trigger: 'blur' }],
          coverPath: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.sizeId) {
      this.getSizeTip();
    }
  },
};
</script>
